"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var continueButtonStyles = makeStyles_1.default(function (theme) {
    var _a;
    return ({
        continueButton: (_a = {
                marginRight: '30px',
                borderRadius: '4px'
            },
            _a[theme.breakpoints.down('xs')] = {
                marginRight: 0,
            },
            _a),
        newContainedPrimary: {},
        newContained: {},
        loader: {
            marginRight: '5px',
        },
    });
}, { name: 'Checkout4_ContinueButton' });
exports.default = continueButtonStyles;
